import { render, staticRenderFns } from "./ChartGluTable.vue?vue&type=template&id=1274f845&scoped=true"
import script from "./ChartGluTable.vue?vue&type=script&lang=js"
export * from "./ChartGluTable.vue?vue&type=script&lang=js"
import style0 from "./ChartGluTable.vue?vue&type=style&index=0&id=1274f845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274f845",
  null
  
)

export default component.exports